// @flow

import { type LookAndFeel } from '@tectonics/look-and-feel';

const shopifyEmbedded: LookAndFeel = {
  code: 'shopify-embedded',
  displayName: 'Shopify Embedded',
  getRootComponent: () => import('./shopify-embedded'),
  getLoadingPage: () => import('./pages/loading-payment'),
  prsSupport: {
    integrations: {
      br: ['creditcard', 'debitcard', 'pix', 'boleto', 'ewallet'],
      cl: ['creditcard', 'webpay', 'multicaja', 'sencillito', 'servipag'],
      co: ['baloto', 'creditcard'],
      mx: ['creditcard', 'oxxo', 'spei'],
      uy: ['creditcard', 'debitcard'],
    },
    features: [
      { name: 'action_boleto_copy_code' },
      { name: 'action_boleto_save_pdf' },
      { name: 'display_boleto_barcode' },
      { name: 'display_boleto_due_date' },
      { name: 'display_boleto_email_warning' },
      { name: 'display_boleto_number' },
      { name: 'display_boleto_tips' },
      { name: 'display_boleto_total_value' },
      { name: 'display_merchant_logo' },
      { name: 'display_receipt_brazilian_tax_iof' },
      { name: 'display_receipt_final_amount' },
      { name: 'display_receipt_original_amount' },
      { name: 'display_selected_instalment' },
      { name: 'field_accept_terms' },
      { name: 'field_brazilian_document', traits: ['type_cpf'] },
      { name: 'field_brazilian_phone_number' },
      { name: 'field_brazilian_zipcode' },
      { name: 'field_mexican_phone_number' },
      { name: 'field_mexican_zipcode' },
      { name: 'field_captcha_token' },
      { name: 'field_card_expiry_date' },
      { name: 'field_card_holder_name' },
      { name: 'field_card_instalments' },
      { name: 'field_card_number' },
      { name: 'field_card_security_code' },
      { name: 'field_customer_email' },
      {
        name: 'display_card_accepts_brand',
        traits: ['visa', 'mastercard', 'amex', 'carnet', 'diners', 'discover', 'elo', 'hipercard', 'naranja', 'credimas', 'cabal'],
      },
      { name: 'display_debit_card_accepts_brand', traits: ['bancobrasil', 'caixa', 'santander','nubank'] },
      { name: 'filed_ewallet_select_wallet' },
      { name: 'display_ewallet_accepts_brand', traits: ['ame', 'mercadopago', 'paypal', 'picpay'] },
      { name: 'display_spei_mail_warning' },
      { name: 'display_spei_total_amount' },
      { name: 'display_spei_due_date' },
      { name: 'display_spei_destination_clabe_number' },
      { name: 'display_spei_reference_number' },
      { name: 'display_spei_destination_bank' },
      { name: 'display_spei_destination_beneficiary' },
      { name: 'field_colombian_document_type' },
      { name: 'field_colombian_document' },
      { name: 'field_colombian_phone_number' },
      { name: 'field_colombian_zipcode' },
      { name: 'field_uruguayan_document' },
      { name: 'field_chilean_document' },
      { name: 'field_chilean_phone_number' },
    ],
  },
};

export default shopifyEmbedded;
